import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=bdb212d2&scoped=true&"
import script from "./Modal.vue?vue&type=script&lang=js&"
export * from "./Modal.vue?vue&type=script&lang=js&"
import style0 from "../base/assets/css/base.css?vue&type=style&index=0&lang=css&"
import style1 from "./Modal.vue?vue&type=style&index=1&id=bdb212d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb212d2",
  null
  
)

export default component.exports